<template>
  <nav class="navbar">
    <router-link to="/">
      <i class="icon-home"></i>
      <span>首页</span>
    </router-link>
    <router-link to="/item">
      <i class="icon-art"></i>
      <span>典藏精品</span>
    </router-link>
    <router-link to="/brand">
      <i class="icon-chiilih"></i>
      <span>品牌故事</span>
    </router-link>
    <router-link to="/coral">
      <i class="icon-coral"></i>
      <span>认识珊瑚</span>
    </router-link>
    <router-link to="/link">
      <i class="icon-link"></i>
      <span>相关链接</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'navs',
  data() {
    return {}
  },
  created() {},
  methods: {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
$red: rgb(219, 4, 15);
$gol: rgb(143, 116, 53);
$gol-lig: rgb(187, 162, 103);

_::-webkit-full-page-media,
_:future,
:root nav.navbar {
  background-color: rgba(255, 255, 255, 0.88);
  background-color: rgba(255, 255, 255, 1);
  -webkit-backdrop-filter: blur(10px);
}

nav.navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  height: 64px;
  background-color: rgba(255, 255, 255, 0.97);
  background-color: rgba(255, 255, 255, 1);
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  a {
    font-size: 0.8rem;
    text-align: center;
    color: $gol-lig;
    width: 20%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;
    & + .router-link-active {
      // color: #da050f;
      i {
        color: rgba(255, 255, 255, 0.77);
        z-index: 1;
        &::before {
          margin-top: -15px;
          transform: scale(1.2);
          transition: all 0.3s;
        }
      }
      span {
      }
      &::before {
        background-color: rgba($red, 1);
        border: 3px solid #fff;
        // border: 1px solid rgb(255, 76, 76);
        transform: scale(1.3);
        box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);
        // box-shadow: 0 1px 0px .5px rgb(255, 76, 76), 0 3px 12px 0 $red;
        top: -4px;
        animation-duration: activelink 0.6s;
      }
    }
    &::before {
      content: '';
      position: absolute;
      top: -4px;
      padding: 0;
      left: 50%;
      margin-left: -21px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      display: block;
      background-color: rgba($red, 0);
      transform: scale(0.7);
      transition: all 0.3s;
    }
    i {
      width: 100%;
      height: 46px;
      display: block;
      font-size: 1.6rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin: 2px 0 -2px 0;
      &.icon-home {
        font-size: 1.3rem;
      }
      &.icon-voice {
        font-size: 1.4rem;
      }
      &.icon-link {
        font-size: 1.2rem;
      }
    }
    span {
      display: block;
      width: 100%;
      height: 18px;
      padding: 0;
      color: $gol-lig;
      display: flex;
      flex-wrap: wrap;
      align-items: start;
      justify-content: center;
    }
  }
}

@keyframes activelink {
  from {
    background-color: rgba($red, 0);
    transform: scale(0.6);
  }
  to {
    background-color: rgba($red, 1);
    transform: scale(1);
  }
}
</style>






// WEBPACK FOOTER //
// src/components/nav.vue